import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {IpRule} from '../../../../../models/ip-rule';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../../../../services/auth/auth.service';
import {IpRuleService} from '../../../../../services/ip-rule/ip-rule.service';
import {InputSwitchComponent} from '../../../../layout/input-switch/input-switch.component';
import { NgOptimizedImage } from '@angular/common';
import {DropdownSelectComponent} from '../../../../layout/dropdown-select/dropdown-select.component';
import {
  DropdownSelectOptionComponent
} from '../../../../layout/dropdown-select-option/dropdown-select-option.component';
import {CountryService} from '../../../../../services/country/country.service';
import {Country} from '../../../../../models/country';

@Component({
  selector: 'app-ip-rule-form',
  imports: [
    InputSwitchComponent,
    ReactiveFormsModule,
    RouterLink,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    NgOptimizedImage
],
  templateUrl: './ip-rule-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ip-rule-form.component.scss'
})
@IsGranted(['IP_RULE_VIEW', 'ROLE_API_IP_RULE_WRITE'])
@MetaTitle('IP rules')
export class IpRuleFormComponent implements OnInit {
  ipRule: IpRule | null = null;
  countries: Country[] = [];

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    type: new FormControl('ip', Validators.required),
    ip: new FormControl(''),
    countryCode: new FormControl(''),
    allowed: new FormControl(false),
    position: new FormControl(0),
  });

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private ipRuleService: IpRuleService,
    protected countryService: CountryService
  ) {
  }

  ngOnInit(): void {
    this.loader.startLoading();

    const id = Number(this.route.snapshot.paramMap.get('id'));

    this.countryService.findAll().subscribe(countries => {
      this.countries = countries;

      if (id) {
        this.ipRuleService.findOneById(id).subscribe((ipRule: IpRule) => {
          this.ipRule = ipRule;

          this.form.patchValue({
            name: ipRule.name,
            type: ipRule.type,
            ip: ipRule.ip,
            countryCode: ipRule.countryCode,
            allowed: ipRule.allowed,
            position: ipRule.position
          });

          this.loader.stopLoading();
        });
      } else {
        this.loader.stopLoading();
      }
    });
  }

  isCreate(): boolean {
    return !this.ipRule;
  }

  canUpdate(): boolean {
    return this.auth.hasRolesSync(['ROLE_API_IP_RULE_WRITE']);
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this.loader.startLoading();

    let params: any = this.form.value;

    if (this.isCreate()) {
      this.ipRuleService.create(params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Rule has been created.');
        this.router.navigateByUrl('/configuration/ip-rules').then();
      });
    } else if (this.ipRule?.id) {
      this.ipRuleService.update(this.ipRule.id, params).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Rule has been modified.');
        this.router.navigateByUrl('/configuration/ip-rules').then();
      });
    }
  }

  isTypeIp(): boolean {
    return this.form.get('type')?.value === 'ip';
  }
}
